import { useState } from "react";
import { Link } from "react-router-dom";
import { Copy, Check, ArrowRight, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { money } from "../../lib/api";

const NEXT = [
  { t: "Review", d: "A coordinator verifies your route, details and price." },
  { t: "Invoice", d: "You receive your official invoice with payment instructions." },
  { t: "Payment", d: "Card payment link, bank transfer, or cash on delivery." },
  { t: "Carrier booked", d: "Once payment clears, we book a fully insured carrier." },
];

export const RegisterSuccess = ({ result }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(result.tracking_number);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = result.tracking_number; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    setCopied(true);
    toast.success("Tracking number copied");
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div className="rise" data-testid="register-success">
      <div className="flex items-center gap-3 text-emerald-600"><CheckCircle2 className="w-6 h-6" /><span className="font-mono text-xs uppercase tracking-[0.25em]">Shipment registered</span></div>
      <h1 className="mt-4 font-display font-black uppercase text-slate-900 text-4xl sm:text-5xl leading-none">You're on the board.</h1>
      <p className="mt-4 text-slate-600 max-w-xl">We've emailed a confirmation with your summary. Keep this tracking number handy.</p>
      <div className="mt-8 panel border-amber-500/60 p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center justify-between gap-5">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Tracking number</div>
          <div className="mt-2 font-mono font-bold text-4xl sm:text-5xl text-brand-600 tracking-[0.12em]" data-testid="success-tracking-number">{result.tracking_number}</div>
          <div className="mt-2 text-sm text-slate-600">{result.item_summary} · {result.origin.city}, {result.origin.state} → {result.destination.city}, {result.destination.state} · est. {money(result.quote.estimate)}</div>
        </div>
        <div className="flex gap-3">
          <button onClick={copy} className="btn-ghost" data-testid="copy-tracking-id-button">{copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}{copied ? "Copied" : "Copy"}</button>
          <Link to={`/track/${result.tracking_number}`} className="btn-amber" data-testid="success-track-now-link">Track now <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </div>
      <div className="mt-12">
        <div className="font-display font-bold uppercase text-slate-900 text-2xl">What happens next</div>
        <ol className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200" data-testid="success-next-steps">
          {NEXT.map((n, i) => (
            <li key={n.t} className="bg-white p-6">
              <span className="font-mono text-orange-600 text-xs">{String(i + 1).padStart(2, "0")}</span>
              <div className="mt-3 font-display font-bold uppercase text-slate-900 text-lg">{n.t}</div>
              <p className="mt-2 text-sm text-slate-600">{n.d}</p>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};
